module.exports = __webpack_public_path__ + "static/media/dst-on.a6ab57dc.webp";